module.exports = "<div class=nn-spinner><div class=rect1></div><div class=rect2></div><div class=rect3></div><div class=rect4></div><div class=rect5></div></div>"


//////////////////
// WEBPACK FOOTER
// ./app/components/nn-generic-directives/nn-spinner/nn-spinner.directive.html
// module id = 972
// module chunks = 0